<div class="professional-admin" data-testid="professional-admin-container">
  <nav class="professional-admin__tabs" data-testid="professional-admin-tabs">
    <wil-admin-tabs (tabChange)="onTabChange($event)"></wil-admin-tabs>
  </nav>

  <div class="professional-admin__content" data-testid="professional-admin-content">
    @switch (activeTab()) { @case ('wheels') {
    <div class="professional-admin__tab-content" data-testid="professional-admin-wheels-content">
      <wil-admin-tab-wheel
        [wheels]="savedWheels$ | async"
        [accountId]="accountId"
        (createWheelClick)="onCreateWheel()"
      ></wil-admin-tab-wheel>
    </div>
    } @case ('clients') {
    <div class="professional-admin__tab-content" data-testid="professional-admin-clients-content">
      <wil-admin-tab-client
        [clients]="(clients$ | async)"
        [isLoading]="isLoadingClients()"
        [error]="clientsError$ | async"
        (createClientClick)="onCreateClient()"
        (retryLoadClick)="loadClients()"
      ></wil-admin-tab-client>
    </div>
    } @case ('brand') {
    <div class="professional-admin__tab-content" data-testid="professional-admin-brand-content">
      <wil-admin-tab-brand [brand]="(brand$ | async)"></wil-admin-tab-brand>
    </div>
    } }
  </div>
</div>
